<template>
  <v-card :elevation="6" class="mx-auto pa-2 rounded-lg" style="min-height: 320px;">
    <grafico-vazio v-if="dados.length === 0" :min-height="320" />
    <grafico-barras-verticais
      v-else
      id="grafico-evolucao-mensal"
      :category-field="`mes`"
      :value-field="`valor`"
      :dados="dados"
      :title="`R$ ${$tc('label.evolucao_mensal', 1)}`"
      :colors="cores"
      :height="320"
    />
  </v-card>
</template>

<script>
import GraficoBarrasVerticais from '@/produto/shared-components/chart/GraficoBarrasVerticais';
import { getAbrMonth, getNomeMesExtenso } from '@/produto/common/functions/month';
import { buscarEvolucaoMensal } from '@/common/resources/akzo-chart';
import GraficoVazio from './GraficoVazio';

export default {
  name: 'GraficoBarrasEvolucaoMensal',
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    params: {
      handler() {
        this.buscarDados();
      },
      deep: true,
    },
  },
  components: {
    GraficoBarrasVerticais,
    GraficoVazio,
  },
  data() {
    return {
      dados: [],
      cores: ['#878787'],
    };
  },
  methods: {
    buscarDados() {
      buscarEvolucaoMensal(this.params, this.$resource)
        .then((response) => {
          const anoFiscal = this.params.anoFiscal || new Date().getFullYear();
          let dadosFiltrados = (response.data || [])
            .filter((item) => item.mes !== null);

          if (this.params.mes) {
            dadosFiltrados = dadosFiltrados.filter((item) => item.mes === this.params.mes);
          }

          this.dados = dadosFiltrados.map((item) => ({
            mes: getAbrMonth(item.mes),
            mesExtensoAno: `${getNomeMesExtenso(item.mes)} - ${anoFiscal}`,
            valor: item.valor || 0,
          }));
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
  },
  mounted() {
    this.buscarDados();
  },
};
</script>
